import { TFunction } from 'next-i18next'
import { PaymentSetupProps, PayNowInput, PayNowInputProps } from '../PayNowModalContext'
import { getSingleInstallmentSequence } from '../utils'

export const getPaymentLabel = (payment: PaymentSetupProps, payNowStep: PayNowInputProps, t: TFunction): string => {
  switch (payNowStep) {
    case PayNowInput.NEXT:
      return t('payments:customPayment:installmentsv2:base:headings:next')
    case PayNowInput.REMAINING:
      return t('payments:customPayment:installmentsv2:base:headings:total')
    case PayNowInput.CUSTOM:
      return t('payments:customPayment:installmentsv2:base:subheadings:custom:payment')
    default: {
      const sequence = getSingleInstallmentSequence(payment)
      if (typeof sequence === 'number') {
        const translationKey = `payments:customPayment:payment:label:sequence:${sequence - 1}`
        return t(translationKey, { defaultValue: t('payments:customPayment:payment:label:total') })
      }
      return t('payments:customPayment:payment:label:total')
    }
  }
}
